<template>
  <div class="pa-4">
    <v-card>
      <v-card-title>
        <span class="text-h6">Clientes</span>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="openDialog('add')">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="clients"
        item-value="id"
        dense
        class="elevation-1 custom-table pl-2"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Buscar"
            outlined
            dense
            class="mx-4 small-input"
          ></v-text-field>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="openDialog('edit', item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.type="{ item }">
          <v-chip
            small
            outlined
            dark
                  color="primary"

          >
            {{ item.tax_condition ? 'P.Jurídica' : 'P.Física' }}
          </v-chip>
        </template>
      <template v-slot:item.phone="{ item }">
        <div class="d-flex align-center">
          <a
            v-if="item.phone && isValidPhoneNumber(item.phone)"
            :href="getWhatsAppLink(item.phone)"
            target="_blank"
            rel="noopener"
            class="d-flex align-center  no-underline"
          >
            <span>{{ item.phone }}</span>
            <v-icon small color="green darken-1" class="ml-1">mdi-whatsapp</v-icon>
          </a>

          <span v-else>
            {{ item.phone || 'Sin teléfono' }}
          </span>
        </div>
      </template>
      <template v-slot:item.address="{ item }">
        <div
          class="text-truncate"
          :title="item.address"
          style="max-width: 250px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
        >
          {{ item.address }}
        </div>
      </template>
      <template v-slot:item.first_name="{ item }">
        <div
          class="text-truncate"
          :title="item.first_name"
          style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
        >
          {{ item.first_name }}
        </div>
      </template>
      </v-data-table>
    </v-card>
    <ClientDialog
      v-model="dialog"
      :action="dialogAction"
      :client="selectedClient"
      @save-client="onClientSaved"
      @update-client="onClientUpdated"
    />

    <v-overlay :value="overlay" :z-index="3000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import ClientDialog from "@/components/Client.vue";
import axios from "@/plugins/axios.js";

export default {
  components: { ClientDialog },

  data() {
    return {
      search: "",
      //Para modal user
      dialog: false,
      selectedClient: null,
      dialogAction: "",

      headers: [
        { text: "Dni", value: "dni" },
        { text: "Cuit", value: "cuit" },
        { text: "Nombre", value: "first_name" },
        { text: "Apellido", value: "last_name" },
        { text: "Tipo", sortable: false, value: "type" },
        { text: "Correo Electrónico", value: "email" },
        { text: "Teléfono", value: "phone" },
        { text: "Dirección", value: "address" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      clients: [],
      overlay: false,
    };
  },

  mounted() {
    this.getClients();
  },

  methods: {
    isValidPhoneNumber(phone) {
      if (!phone || typeof phone !== "string") return false;
      const clean = phone.replace(/[^0-9]/g, "");
      return clean.length >= 10 && /^\d+$/.test(clean);
    },
    getWhatsAppLink(phone) {
      if (!phone || typeof phone !== "string") return null;
      const clean = phone.replace(/[^0-9]/g, "");
      if (!this.isValidPhoneNumber(phone)) return null;
      return `https://wa.me/${clean}`;
    },
    getClients() {
      this.overlay = true;
      axios
        .get("/clients/getClients")
        .then((response) => {
          this.clients = [...response.data];
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    openDialog(action, client = null) {
      this.dialogAction = action;
      this.selectedClient = client ? { ...client } : null;
      this.dialog = true;
    },
    onClientSaved(resp) {
      const client = resp.client;
      const index = this.clients.findIndex((c) => c.id === client.id);
      if (index !== -1) {
        this.clients.splice(index, 1, client);
      } else {
        this.clients.push(client);
      }
    },
    onClientUpdated(resp) {
      const client = resp.client;
      const index = this.clients.findIndex((c) => c.id === client.id);
      if (index !== -1) {
        this.clients.splice(index, 1, client);
      }
    },
  },
};
</script>

<style scoped>
a.no-underline {
  text-decoration: none;
}
.custom-table {
  font-size: 12px !important;
  table-layout: fixed; /* importante */
  width: 100%;
}

.custom-table >>> table {
  width: 100%;
}

.custom-table >>> th,
.custom-table >>> td {
  font-size: 12px !important;
  padding: 6px 10px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 100px; /* valor por defecto, puede sobrescribirse en columnas específicas */
}
.v-btn-toggle {
  background-color: #f5f5f5;
  border-radius: 8px;
}
.v-btn-toggle .v-btn {
  min-width: 48px;
  padding: 0;
}
.small-input .v-input__control {
  height: 30px !important;
  font-size: 9pt;
  padding: 4px 8px !important;
}
.small-input .v-label {
  font-size: 0.75rem;
  top: -6px;
}
</style>
